/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-03-15 13:46:20
 * Copyright 2022 Leedarson, All Rights Reserved.
 */

import React from 'react';
import { ICellTitle } from './types';

const CellTitle = ({
  title,
  children,
  color,
  paddingTop,
  paddingBottom,
  enhance,
}: ICellTitle) => {
  return (
    <div
      className={`cell-title ${enhance ? 'enhance' : ''}`}
      style={{ color, paddingTop, paddingBottom }}
    >
      {title}
      {children}
    </div>
  );
};

export default CellTitle;
